import { Box, Typography } from '@mui/material';
import { SHELL_BRAND } from './brand';

/** Edge of the brand mark in px; the rail centers it on this. */
export const BRAND_MARK_SIZE = 30;

type BrandLogoProps = {
  /** Fade out the wordmark (collapsed rail keeps only the mark). */
  labelVisible?: boolean;
};

/** Colored-dots brand mark + two-line sponsor name. */
export const BrandLogo = ({ labelVisible = true }: BrandLogoProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
    <svg
      width={BRAND_MARK_SIZE}
      height={BRAND_MARK_SIZE}
      viewBox="0 0 26 26"
      fill="none"
      role="presentation"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <circle cx="8" cy="9" r="4.2" fill="#7E57C2" />
      <circle cx="15" cy="7" r="3" fill="#EC407A" />
      <circle cx="16.5" cy="14.5" r="3.6" fill="#FF7043" />
      <circle cx="9.5" cy="16.5" r="2.6" fill="#42A5F5" />
    </svg>
    <Box
      sx={{
        lineHeight: 1.05,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: labelVisible ? 'auto' : 0,
        opacity: labelVisible ? 1 : 0,
        transition: 'opacity 150ms',
      }}
    >
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 800,
          letterSpacing: '-0.01em',
          lineHeight: 1.05,
        }}
      >
        {SHELL_BRAND.sponsorLine1}
      </Typography>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          color: 'primary.main',
          lineHeight: 1.05,
        }}
      >
        {SHELL_BRAND.sponsorLine2}
      </Typography>
    </Box>
  </Box>
);
